import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonGroup, Message } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { actions as worksheetActions } from 'Data/ReduxViewModels/WorksheetEditor';
import { Guid } from 'Lib/Guid';
import { IReImportButtonProps } from 'Data/ViewModels/Core/IReImportButtonProps';

const ReImportButtonBase: React.FC<IReImportButtonProps> = ({ value, warningMessage, createWorksheetSelector }) => {
  const dispatch = useDispatch();
  const worksheetId = useSelector(createWorksheetSelector!('data.Id', false)) as Guid;

  const reimportVisible = value && value.Id && value.Mismatch;

  const reimport = () => {
    value &&
      dispatch(
        worksheetActions.import({
          worksheetId: worksheetId,
          importModel: { Id: value.Id },
        })
      );
  };
  return reimportVisible ? (
    <>
      {warningMessage ? <Message warning>{warningMessage}</Message> : null}
      <ButtonGroup>
        <Button onClick={reimport}>Re-Import</Button>
      </ButtonGroup>
    </>
  ) : null;
};

const ReImportButton = withInjectedProps(ReImportButtonBase);

export default ReImportButton;
